export default __webpack_public_path__ + "static/27-04-02e1a8e55d8a9ef8ccba346a1766fe6f.jpg";